import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import merge from 'deepmerge';
import { forkJoin, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ConfigurationService } from "../components/configuration-select/configuration.service";
export interface ITranslationResource {
	prefix: string;
	suffix: string;
}

export class CustomMultiTranslateHttpLoader implements TranslateLoader {
	constructor(
		private http: HttpClient,
		private resources: ITranslationResource[],
		private configuration: ConfigurationService
	) { }

	public getTranslation(lang: string): Observable<any> {
		let resources = [];
		this.resources.forEach((res) => resources.push(res));

		if (this.configuration && this.configuration.SelectedConfigOid)
			resources.push({ prefix: './assets/i18n/specific_' + this.configuration.SelectedConfigOid + '_', suffix: '.json' })
		const requests = resources.map(resource => {
			const path = resource.prefix + lang + resource.suffix;
			return this.http.get(path).pipe(catchError(res => {
				console.error("Something went wrong for the following translation file:", path);
				console.error(res.message);
				return of({});
			}));
		});
		return forkJoin(requests).pipe(map(response => merge.all(response)));
	}
}